import styled, { css } from "styled-components";

import { DESKTOP_BREAKPOINT } from "../AppShell/styles";

type Props = {
  hideLine?: boolean;
  hideBox?: boolean;
};

export const Container = styled.div<Props>`
  background: ${props => !props.hideBox && "var(--color-neutral-darkness)"};

  position: fixed;
  right: var(--app-preview-width, 0px);
  bottom: var(--app-bottom-bar-offset, 0px);
  left: var(--app-sidebar-width, 0px);
  width: min(720px, calc(100% - var(--app-sidebar-width, 0px) - var(--app-preview-width, 0px)));
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  justify-content: center;

  /* Same look as the sticky SaveBar: a solid bar with a line on top that stops where the content does (the
     side padding) instead of running edge to edge, in the app's line color */
  ${props =>
    !props.hideBox &&
    css`
      &::before {
        position: absolute;
        top: 0;
        right: 2rem;
        left: 2rem;
        height: 1px;
        content: "";
        background: var(--color-neutral-dark);
      }

      @media not all and (min-width: ${DESKTOP_BREAKPOINT}) {
        &::before {
          right: 20px;
          left: 20px;
        }
      }
    `}
`;

export const ContentSection = styled.div<Props>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;

  @media not all and (min-width: ${DESKTOP_BREAKPOINT}) {
    padding: 1rem 20px;
  }
`;

export const OutsiteComponent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: -0.5rem;
  z-index: 9999;
`;
